"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "THEME": "themes/Allianz",
    "THEME_PATH": "themes/Allianz",
    "THEME_NAME": "Allianz",
    "TRADEMARK": "This insurance is sold, underwritten and administered by Liverpool Victoria Insurance Company Limited, which is an Allianz Group company, registered in England and Wales number 3232514. Authorised by the Prudential Regulation Authority and regulated by the Financial Conduct Authority and the Prudential Regulation Authority, register number 202965. Registered address: 57 Ladymead, Guildford, Surrey, GU1 1DB. Allianz is a trading name of Liverpool Victoria Insurance Company Limited.",
    "WHATEVER_YOU_DECIDE": "Whatever you decide, we’ll make it happen.",
    "COMPLAINT_EMAIL": "digitalhelp@allianz.co.uk",
    "HELP_EMAIL": "digitalhelp@allianz.co.uk",
    "UNDERWRITER": "underwritten by Liverpool Victoria Insurance Company Limited, which is an Allianz Group company",
    "FAQ_URL": "https://insurewithvolkswagen.co.uk/car-insurance#faqs",
    "PHONE_NUMBER": "",
    "DRIVE_PHONE_NUMBER": "",
    "CONTACT_EMAIL": "",
    "CONTACT_PHONE_NUMBER": "",
    "TRADEMARK_BRAND": "",
};
//# sourceMappingURL=resource.js.map